import React, { useState } from 'react';
import { LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Phone, Mail, Linkedin, Facebook, ChevronDown } from 'lucide-react';
// Mock Data for Employee Headcount (2010 - 2025)
const headcountData = [{
  date: 'Jan-10',
  count: 30
}, {
  date: 'Jul-10',
  count: 32
}, {
  date: 'Jan-11',
  count: 36
}, {
  date: 'Jul-11',
  count: 38
}, {
  date: 'Jan-12',
  count: 42
}, {
  date: 'Jul-12',
  count: 44
}, {
  date: 'Jan-13',
  count: 48
}, {
  date: 'Jul-13',
  count: 49
}, {
  date: 'Jan-14',
  count: 51
}, {
  date: 'Jul-14',
  count: 52
}, {
  date: 'Jan-15',
  count: 55
}, {
  date: 'Jul-15',
  count: 56
}, {
  date: 'Jan-16',
  count: 51
}, {
  date: 'Jul-16',
  count: 45
}, {
  date: 'Jan-17',
  count: 42
}, {
  date: 'Jul-17',
  count: 40
}, {
  date: 'Jan-18',
  count: 43
}, {
  date: 'Jul-18',
  count: 44
}, {
  date: 'Jan-19',
  count: 45
}, {
  date: 'Jul-19',
  count: 46
}, {
  date: 'Jan-20',
  count: 45
}, {
  date: 'Jul-20',
  count: 47
}, {
  date: 'Jan-21',
  count: 48
}, {
  date: 'Jul-21',
  count: 46
}, {
  date: 'Jan-22',
  count: 45
}, {
  date: 'Jul-22',
  count: 47
}, {
  date: 'Jan-23',
  count: 48
}, {
  date: 'Jul-23',
  count: 49
}, {
  date: 'Jan-24',
  count: 48
}, {
  date: 'Jul-24',
  count: 49
}, {
  date: 'Jan-25',
  count: 50
}, {
  date: 'Jul-25',
  count: 49
}];
// Mock Data for Headcount by Role (2018 - 2025)
const roleData = [{
  date: 'Jan-18',
  Sales: 12,
  Operations: 8,
  Accounting: 4,
  HR: 2,
  Warehouse: 10,
  CS: 4,
  Management: 3,
  IT: 0
}, {
  date: 'Jul-18',
  Sales: 13,
  Operations: 8,
  Accounting: 4,
  HR: 2,
  Warehouse: 10,
  CS: 4,
  Management: 3,
  IT: 0
}, {
  date: 'Jan-19',
  Sales: 13,
  Operations: 9,
  Accounting: 4,
  HR: 2,
  Warehouse: 10,
  CS: 4,
  Management: 3,
  IT: 0
}, {
  date: 'Jul-19',
  Sales: 14,
  Operations: 9,
  Accounting: 4,
  HR: 2,
  Warehouse: 10,
  CS: 4,
  Management: 3,
  IT: 0
}, {
  date: 'Jan-20',
  Sales: 14,
  Operations: 8,
  Accounting: 4,
  HR: 2,
  Warehouse: 10,
  CS: 4,
  Management: 3,
  IT: 0
}, {
  date: 'Jul-20',
  Sales: 15,
  Operations: 8,
  Accounting: 4,
  HR: 2,
  Warehouse: 11,
  CS: 4,
  Management: 3,
  IT: 0
}, {
  date: 'Jan-21',
  Sales: 15,
  Operations: 9,
  Accounting: 4,
  HR: 2,
  Warehouse: 11,
  CS: 4,
  Management: 3,
  IT: 0
}, {
  date: 'Jul-21',
  Sales: 14,
  Operations: 9,
  Accounting: 4,
  HR: 2,
  Warehouse: 10,
  CS: 4,
  Management: 3,
  IT: 0
}, {
  date: 'Jan-22',
  Sales: 14,
  Operations: 8,
  Accounting: 4,
  HR: 2,
  Warehouse: 10,
  CS: 4,
  Management: 3,
  IT: 0
}, {
  date: 'Jul-22',
  Sales: 15,
  Operations: 8,
  Accounting: 4,
  HR: 2,
  Warehouse: 11,
  CS: 4,
  Management: 3,
  IT: 0
}, {
  date: 'Jan-23',
  Sales: 16,
  Operations: 9,
  Accounting: 4,
  HR: 2,
  Warehouse: 11,
  CS: 4,
  Management: 3,
  IT: 1
}, {
  date: 'Jul-23',
  Sales: 16,
  Operations: 9,
  Accounting: 4,
  HR: 2,
  Warehouse: 11,
  CS: 5,
  Management: 3,
  IT: 1
}, {
  date: 'Jan-24',
  Sales: 15,
  Operations: 9,
  Accounting: 4,
  HR: 2,
  Warehouse: 11,
  CS: 5,
  Management: 3,
  IT: 1
}, {
  date: 'Jul-24',
  Sales: 16,
  Operations: 9,
  Accounting: 4,
  HR: 2,
  Warehouse: 11,
  CS: 5,
  Management: 3,
  IT: 1
}, {
  date: 'Jan-25',
  Sales: 16,
  Operations: 9,
  Accounting: 4,
  HR: 2,
  Warehouse: 12,
  CS: 5,
  Management: 3,
  IT: 1
}, {
  date: 'Jul-25',
  Sales: 15,
  Operations: 9,
  Accounting: 4,
  HR: 2,
  Warehouse: 12,
  CS: 5,
  Management: 3,
  IT: 1
}];
const departments = [{
  key: 'Sales',
  color: '#4f46e5',
  label: 'Sales'
}, {
  key: 'Operations',
  color: '#0ea5e9',
  label: 'Operations'
}, {
  key: 'Accounting',
  color: '#10b981',
  label: 'Accounting'
}, {
  key: 'HR',
  color: '#f59e0b',
  label: 'Human Resources'
}, {
  key: 'Warehouse',
  color: '#8b5cf6',
  label: 'Warehouse'
}, {
  key: 'CS',
  color: '#ec4899',
  label: 'Customer Service'
}, {
  key: 'Management',
  color: '#ef4444',
  label: 'Management'
}, {
  key: 'IT',
  color: '#64748b',
  label: 'IT'
}];
const principals = [{
  name: 'Michael Scott',
  role: 'Regional Manager',
  phone: '(570) 555-0100',
  email: 'm.scott@dundermifflin.com',
  status: 'Current',
  previous: ['Paper Unlimited (1990-1992)'],
  socials: ['linkedin'],
  linkedin: 'https://www.linkedin.com/in/michael-scott-824680351/'
}, {
  name: 'Dwight Schrute',
  role: 'Asst. Regional Manager',
  phone: '(570) 555-0101',
  email: 'd.schrute@dundermifflin.com',
  status: 'Current',
  previous: ['Schrute Farms (1995-Present)'],
  socials: ['linkedin'],
  linkedin: 'https://www.linkedin.com/in/dwight-schrute-816386219/'
}, {
  name: 'Jim Halpert',
  role: 'Sales Director',
  phone: '(570) 555-0102',
  email: 'j.halpert@dundermifflin.com',
  status: 'Current',
  previous: [],
  socials: ['linkedin'],
  linkedin: 'https://www.linkedin.com/in/jim-halpert-630766267/'
}, {
  name: 'David Wallace',
  role: 'CFO',
  phone: '(570) 555-0105',
  email: 'd.wallace@dundermifflin.com',
  status: 'Current',
  previous: ['Dunder Mifflin Corporate (2000-Present)'],
  socials: ['linkedin'],
  linkedin: '#'
}];
export function PeopleTab() {
  const [activeDepartments, setActiveDepartments] = useState<string[]>(departments.map(d => d.key));
  const toggleDepartment = (key: string) => {
    if (activeDepartments.includes(key)) {
      setActiveDepartments(activeDepartments.filter(d => d !== key));
    } else {
      setActiveDepartments([...activeDepartments, key]);
    }
  };
  const toggleAll = () => {
    if (activeDepartments.length === departments.length) {
      setActiveDepartments([]);
    } else {
      setActiveDepartments(departments.map(d => d.key));
    }
  };
  return <div className="space-y-6 mt-6" data-id="element-2990">
      {/* Employee Headcount Chart */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-2991">
        <div className="flex justify-between items-start mb-6" data-id="element-2992">
          <div data-id="element-2993">
            <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-2994">
              Employee Headcount
            </h2>
            <div className="inline-block border-b-2 border-gray-900 pb-1 mb-1" data-id="element-2995">
              <span className="text-xl font-bold text-gray-900" data-id="element-2996">0%</span>
            </div>
            <p className="text-sm text-gray-600" data-id="element-2997">12 Month Growth Rate</p>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-2998">
            ALL <ChevronDown className="w-4 h-4" data-id="element-2999" />
          </button>
        </div>
        <div className="h-72 w-full" data-id="element-3000">
          <ResponsiveContainer width="100%" height="100%" data-id="element-3001">
            <LineChart data={headcountData} margin={{
            top: 5,
            right: 0,
            left: -20,
            bottom: 0
          }} data-id="element-3002">
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-3003" />
              <XAxis dataKey="date" axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} minTickGap={30} data-id="element-3004" />
              <YAxis axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} domain={[0, 60]} ticks={[0, 20, 40, 60]} data-id="element-3005" />
              <Tooltip contentStyle={{
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
            }} data-id="element-3006" />
              <Line type="monotone" dataKey="count" stroke="#000000" strokeWidth={2} dot={false} activeDot={{
              r: 6,
              fill: '#000000'
            }} data-id="element-3007" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Company Principals Table */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-3008">
        <div className="p-6 border-b border-gray-200" data-id="element-3009">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-3010">
            Company Principals
          </h2>
        </div>
        <div className="overflow-x-auto" data-id="element-3011">
          <table className="w-full text-left border-collapse" data-id="element-3012">
            <thead data-id="element-3013">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-3014">
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-3015">
                  Name
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-3016">
                  Role
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-3017">
                  Phone/Email
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-3018">
                  Status
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600" data-id="element-3019">
                  Previous Employers
                </th>
                <th className="px-6 py-3 text-sm font-semibold text-gray-600 text-right" data-id="element-3020">
                  Socials
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-3021">
              {principals.map((principal, idx) => <tr key={idx} className="hover:bg-gray-50/50" data-id="element-3022">
                  <td className="px-6 py-4" data-id="element-3023">
                    <span className="font-bold text-gray-900" data-id="element-3024">
                      {principal.name}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600" data-id="element-3025">
                    {principal.role}
                  </td>
                  <td className="px-6 py-4" data-id="element-3026">
                    <div className="space-y-1" data-id="element-3027">
                      <div className="flex items-center gap-2 text-sm" data-id="element-3028">
                        <Phone className="w-4 h-4 text-gray-400" data-id="element-3029" />
                        <a href={`tel:${principal.phone}`} className="text-indigo-600 hover:underline" data-id="element-3030">
                          {principal.phone}
                        </a>
                      </div>
                      <div className="flex items-center gap-2 text-sm" data-id="element-3031">
                        <Mail className="w-4 h-4 text-gray-400" data-id="element-3032" />
                        <a href={`mailto:${principal.email}`} className="text-indigo-600 hover:underline" data-id="element-3033">
                          {principal.email}
                        </a>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-3034">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${principal.status === 'Current' ? 'bg-gray-100 text-gray-800 border border-gray-200' : 'bg-gray-100 text-gray-500 border border-gray-200'}`} data-id="element-3035">
                      {principal.status}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-3036">
                    {principal.previous.length > 0 ? <ul className="list-disc list-inside text-sm text-gray-600 space-y-0.5" data-id="element-3037">
                        {principal.previous.map((prev, i) => <li key={i} data-id="element-3038">{prev}</li>)}
                      </ul> : <span className="text-sm text-gray-400" data-id="element-3039">-</span>}
                  </td>
                  <td className="px-6 py-4" data-id="element-3040">
                    <div className="flex items-center justify-end gap-2" data-id="element-3041">
                      {principal.socials.includes('linkedin') && <a href={principal.linkedin} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-[#0077b5] flex items-center justify-center text-white hover:opacity-90 transition-opacity" data-id="element-3042">
                          <Linkedin className="w-4 h-4" data-id="element-3043" />
                        </a>}
                      {principal.socials.includes('facebook') && <a href="#" className="w-8 h-8 rounded-full bg-[#1877f2] flex items-center justify-center text-white hover:opacity-90 transition-opacity" data-id="element-3044">
                          <Facebook className="w-4 h-4" data-id="element-3045" />
                        </a>}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}